import { useState } from 'react';
import { getItem, setItem } from '../services/util/localStorage';

const keepValue = (value) => value;

// O localStorage pode estar indisponível (modo privado, cota cheia) ou com JSON inválido: nesses casos o
// estado só não é lembrado, a tela segue funcionando com o valor inicial
function readStoredValue(key, initialValue, sanitize) {
  try {
    const storedValue = getItem(key);
    return storedValue === null ? initialValue : sanitize(storedValue);
  } catch {
    return initialValue;
  }
}

export default function usePersistedState(key, initialValue, sanitize = keepValue) {
  const [value, setValue] = useState(() => readStoredValue(key, initialValue, sanitize));

  const updateValue = (newValue) => {
    setValue(newValue);
    try {
      setItem(key, newValue);
    } catch {
      // sem persistência, o valor fica só em memória até recarregar a página
    }
  };

  return [value, updateValue];
}
